module.exports = __webpack_public_path__ + "img/1.5529287f.png";